import { render, staticRenderFns } from "./SimpleEmailComposer.vue?vue&type=template&id=31cda4a4"
import script from "./SimpleEmailComposer.vue?vue&type=script&lang=js"
export * from "./SimpleEmailComposer.vue?vue&type=script&lang=js"
import style0 from "./SimpleEmailComposer.vue?vue&type=style&index=0&id=31cda4a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports